export default __webpack_public_path__ + "static/media/stethoscope1.b5cd9ce2.svg";